<template>
    <h3 class="de-two-level-title">
        <span class="icon-title"></span>
        <span class="text" :style="styleObj">{{title}}</span>
    </h3>
</template>

<script>
    export default {
        name: "de-two-level-title",
        props: {
            title: {
                type: String,
                default: '二级标题'
            },
            fontObj: {
                type: Object
            },
            paddingLeft: {
                type: Number,
                default: 20
            },
            lineHeight: {
                type: Number,
                default: 50
            },
        },
        computed: {
            styleObj() {
                return this.fontObj
                ? (Object.assign({}, this.fontObj, {
                    fontSize: `${this.fontObj.fontSize}px`,
                    fontStyle: this.fontObj.fontStyle,
                    fontFamily: this.fontObj.fontFamily,
                    fontWeight: this.fontObj.fontWeight,
                    color: this.fontObj.color,
                    paddingLeft: `${this.paddingLeft}px`,
                    lineHeight: `${this.lineHeight}px`
                }))
                : {};
            }
        }
    };
</script>

<style lang="less" scoped>
.de-two-level-title {
    font-size: 0;
    position: relative;
    .icon-title {
        display: inline-block;
        width: 10px;
        height: 12px;
        background-image: url("~@/runtime-components/assets/images/trigon.svg");
        background-size: 100%;
    }
    .text {
        font-family: 'PingFangSC-Medium';
    }
}
</style>